export type Part = { text: string; tag: string | null };

const MARKER = /<(\w+)>(.*?)<\/\1>/g;

/**
 * Splits a translated string on `<tag>…</tag>`, the only markup a catalog may
 * carry (spec §4.1). Anything that is not a matched pair stays literal text,
 * so a translator's typo shows as a stray `<link>` rather than lost words.
 */
export function splitMarkers(s: string): Part[] {
  const parts: Part[] = [];
  let at = 0;
  for (const m of s.matchAll(MARKER)) {
    if (m.index > at) parts.push({ text: s.slice(at, m.index), tag: null });
    parts.push({ text: m[2]!, tag: m[1]! });
    at = m.index + m[0].length;
  }
  if (at < s.length || parts.length === 0) parts.push({ text: s.slice(at), tag: null });
  return parts;
}
